module.exports = "<svg width=\"13\" height=\"12\" viewBox=\"0 0 13 12\" xmlns=\"http://www.w3.org/2000/svg\"><title>Combined Shape</title><path d=\"M12.897 10.817L7.19.742a.794.794 0 0 0-1.378 0L.105 10.817A.79.79 0 0 0 .794 12h11.414c.598 0 .988-.65.69-1.183zM6 4h1v4H6V4zm0 5h1v1H6V9z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/warning.svg
// module id = 893
// module chunks = 0